import { __rest } from './../../external/tslib/tslib.es6.js';
import React from 'react';
import DropdownComponent from './DropdownComponent.js';
import useIsLowerResolution from '../../hooks/useIsLowerResolution.js';

const DropdownSubMenu = (_a) => {
    var { direction = 'right' } = _a, props = __rest(_a, ["direction"]);
    const isLowerResolution = useIsLowerResolution();
    return (React.createElement(DropdownComponent, Object.assign({}, props, { isSubMenu: true, direction: isLowerResolution ? 'bottom' : direction })));
};

export { DropdownSubMenu as default };
